interface KeyValuePair { key: string, value: string | number }
interface AttributeObj { key: string, value: string, weight: number }

export class Tools {

  constructor() {}

  public incrementalArray = (n: number): number[] => {
    return Array.apply(null, {length: n + 1}).map(Number.call, Number).slice(1)
  }

  public beijingDate(): string {
    const d = new Date()
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000)
    const nd = new Date(utc + (3600000 * 8))
    return `${nd.getFullYear()}-${this.twoDigit(nd.getMonth() + 1)}-${this.twoDigit(nd.getDate())}`
  }

  public beijingYearMonthDate(): { year: number, month: number, day: number } {
    const d = new Date()
    const utc = d.getTime() + (d.getTimezoneOffset() * 60000)
    const nd = new Date(utc + (3600000 * 8))
    return { year: nd.getFullYear(), month: nd.getMonth() + 1, day: nd.getDate() }
  }

  private twoDigit(n: number): string {
    return n > 9 ? '' + n : '0' + n
  }

}



// WEBPACK FOOTER //
// ./src/app/models/app/tools.ts